export default ({ documentTracing, type }, { correlationID }) => ({
  ...documentTracing,
  correlationID,
  type,
});
